import { render, staticRenderFns } from "./platenoInput.vue?vue&type=template&id=c768b35c&scoped=true&"
import script from "./platenoInput.vue?vue&type=script&lang=js&"
export * from "./platenoInput.vue?vue&type=script&lang=js&"
import style0 from "./platenoInput.vue?vue&type=style&index=0&id=c768b35c&lang=less&scoped=true&"
import style1 from "./platenoInput.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c768b35c",
  null
  
)

component.options.__file = "platenoInput.vue"
export default component.exports